export default "__VITE_ASSET__ade6c63d__"